<template>
  <div class='SublinkNaveMobi'>
    <div class="cont" @click="push">
      <div class="icon">
        <component v-if="hasIcon" :is="data.icon" tam="20px" color="#000000" :count="false"/>
        <arrow-circle-icon v-else/>
      </div>
      <div class="label">{{ data.name }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ArrowCircleIcon from '../Icons/ArrowCircleIcon'
import { icons } from '@/components/icons'
export default {
  name: 'SublinkNaveMobi',
  components: { ArrowCircleIcon, ...icons },
  props: ['data'],
  computed: {
    // ícone da categoria só se o usuário escolheu um; senão mantém a seta
    hasIcon () {
      return !!this.data.icon && !!icons[this.data.icon]
    }
  },
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts', 'Loading']),
    async push () {
      this.$router.push(`/loja/${this.data.link}`)
      this.Loading(true)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.$emit('goPage', true)
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
          this.Loading(false)
        })
    }
  }
}
</script>

<style scoped>
.SublinkNaveMobi {
}

.cont {
  display: flex;
  width: 100%;
  border-bottom: thin solid #EEEEEE;
}

.icon {
  width: 12%;
  display: flex;
  justify-content: end;
  padding-top: 3%;
  padding-bottom: 3%;
}

.label {
  width: 70%;
  padding-left: 1%;
  display: flex;
  align-items: center;
}

</style>
